const menu = document.getElementById("menu");
const menuButton = document.querySelector('button.menu[commandfor="menu"]');

if (!menu) {
    return;
}

const links = Array.from(menu.querySelectorAll('a[href^="#"]')).filter((link) => {
    const href = link.getAttribute("href") || "";
    return href.length > 1;
});

if (!links.length) {
    return;
}

const getTargetFromLink = (link) => {
    const href = link.getAttribute("href") || "";
    const targetId = decodeURIComponent(href.slice(1));

    if (!targetId) {
        return null;
    }

    return document.getElementById(targetId);
};

const trackedItems = links
    .map((link) => ({
        link,
        target: getTargetFromLink(link),
        item: link.closest("li")
    }))
    .filter((entry) => entry.target);

if (!trackedItems.length) {
    return;
}

const setActiveLink = (activeLink) => {
    trackedItems.forEach(({ link, item }) => {
        const isActive = link === activeLink;
        link.classList.toggle("active", isActive);

        if (item) {
            item.classList.toggle("active", isActive);
        }
    });
};

const isMenuOpen = () => menu.matches(":popover-open");

const closeMenu = () => {
    if (isMenuOpen() && typeof menu.hidePopover === "function") {
        menu.hidePopover();
    }
};

if (menuButton) {
    menuButton.addEventListener("click", (event) => {
        if (typeof menu.showPopover !== "function" || typeof menu.hidePopover !== "function") {
            return;
        }

        event.preventDefault();

        if (isMenuOpen()) {
            menu.hidePopover();
            menuButton.setAttribute("aria-expanded", "false");
            return;
        }

        menu.showPopover();
        menuButton.setAttribute("aria-expanded", "true");
    });
}

const updateActiveLink = () => {
    const topHalfLimit = window.innerHeight * 0.5;

    let bestMatch = null;
    let closestToTop = Number.POSITIVE_INFINITY;

    trackedItems.forEach(({ link, target }) => {
        const targetTop = target.getBoundingClientRect().top;

        if (targetTop < 0 || targetTop > topHalfLimit) {
            return;
        }

        if (targetTop < closestToTop) {
            closestToTop = targetTop;
            bestMatch = link;
        }
    });

    setActiveLink(bestMatch);
};

let isTicking = false;
const requestActiveLinkUpdate = () => {
    if (isTicking) {
        return;
    }

    isTicking = true;

    window.requestAnimationFrame(() => {
        updateActiveLink();
        isTicking = false;
    });
};

window.addEventListener("scroll", requestActiveLinkUpdate, { passive: true });
window.addEventListener("resize", requestActiveLinkUpdate);

links.forEach((link) => {
    link.addEventListener("click", () => {
        closeMenu();
        window.setTimeout(requestActiveLinkUpdate, 50);
    });
});

requestActiveLinkUpdate();